// Ambiente de homologação
import { AuthGuard, AuthInterceptor, RoleGuard, TransactionGuard } from '@sigepe/ngx-sigepe-seguranca';

import { ConfigEnvironment } from './environment.base';

const HOST_OPORTUNIDADES = 'https://homolog-sigepe-api.estaleiro.serpro.gov.br/oportunidades';
const HOST_TALENTOS = 'https://homolog-sigepe-api.estaleiro.serpro.gov.br/banco-talentos/servidor/api';
const SECURITY_HOSTS = ['https://homolog-sigepe-api.estaleiro.serpro.gov.br'];

//Autoriza
const HOST_LOGIN_UNICO = 'https://sso.staging.acesso.gov.br';
const HOST_JSKS = 'http://localhost:8080';
const HOST_API_SIGEPE = 'https://homolog-sigepe-api.estaleiro.serpro.gov.br/seguranca';
const CLIENT_ID = 'staging.sigepe.planejamento.gov.br';
const COOKIE_DOMAIN = '.sigepe.gov.br';
//const COOKIE_DOMAIN = '.estaleiro.serpro.gov.br'; //Para subir o front apontando pra homologação

const config = new ConfigEnvironment(
	HOST_OPORTUNIDADES,
	HOST_TALENTOS,
	SECURITY_HOSTS,
	HOST_LOGIN_UNICO,
	HOST_JSKS,
	HOST_API_SIGEPE,
	CLIENT_ID,
	COOKIE_DOMAIN
);

export const environment = {
	PROVIDER_AUTH: AuthInterceptor,
	GUARDS: [AuthGuard, RoleGuard],
	TRANSACTION: [AuthGuard, TransactionGuard],
	GUARDS_AND_TRANSACTION: [AuthGuard, RoleGuard, TransactionGuard],
	production: true,
	footerUrl: 'https://homolog-sigepe-api.estaleiro.serpro.gov.br/template/rodapeSigepe/text',
	menuUrl: 'https://homolog-sigepe-api.estaleiro.serpro.gov.br/menu-sigepe',
	mensageriaUrl: 'https://desenv.sigepe.csd.serpro/sigepe-ca-mensageiria-web/private/leitor.jsf',
	manualUrl: 'https://hom.bgp.sigepe.gov.br/sigepe-bgp-web-intranet/pages/manual/consultar.jsf',
	sistemaOrigem: 'OPORTUNIDADES',
	menuAddFromRouter: true,
	menuIgnoreRouterGuard: false,
	avaliacaoFuncionalidadeConfiguration: {
		urlApi: 'https://homolog-sigepe-api.estaleiro.serpro.gov.br/pesquisa-avaliacao/avaliacao-servico/v1/'
	},
	chatbotConfiguration: {
		urlApi: 'https://serprobots.estaleiro.serpro.gov.br/web/bot-admissao-p/index.html',
		disable: false
	},
	...config.getEnvironment(),
	sentry: {
		enabled: true,
		environment: 'homolog',
		tracePropagationTargets: ['https://hom.oportunidades.sigepe.gov.br', HOST_OPORTUNIDADES]
	}
};
